// Alguns nomes de tipo de serviço voltam do backend como slug (ex.: "Coletores_de_dados")
// em vez de texto localizado — troca "_" por espaço para exibir corretamente.
export default function formatServiceTypeLabel(name) {
  if (!name) return name;
  return name.replace(/_+/g, " ").trim();
}
